import request from '@/router/axios'

export function confirmImport(data) {
	return request({
		url: '/dist/distProduct/check/work',
		method: 'post',
		data,
	})
}
